import { Link } from "react-router-dom";
import { ICON_URL } from "@/lib/content";

export default function Logo({ size = "md", linkTo = "/", testId = "site-logo" }) {
  const dims = {
    sm: { img: "h-7 w-7", text: "text-lg" },
    md: { img: "h-9 w-9", text: "text-xl" },
    lg: { img: "h-11 w-11", text: "text-2xl" },
  }[size] || { img: "h-9 w-9", text: "text-xl" };

  const inner = (
    <span className="inline-flex items-center gap-2.5" data-testid={testId}>
      <img src={ICON_URL} alt="" className={`${dims.img} object-contain`} style={{ filter: "drop-shadow(0 0 14px rgba(31,168,255,0.25))" }} />
      <span className={`font-display font-bold tracking-tight ${dims.text} text-white leading-none`}>
        Push2<span className="gradient-text">Stream</span>
      </span>
    </span>
  );

  if (!linkTo) return inner;
  return <Link to={linkTo}>{inner}</Link>;
}
